import Vue from 'vue';
import Router from 'vue-router';
import AppLayout from '@/layouts/app-layout/app-layout.vue';
import AppHeaderLayout from '@/layouts/app-header-layout/app-header-layout.vue';
import { sessionService } from '@/providers/services/auth/session';
import ShareableLink from './views/shareable-link/shareable-link';
import * as LoginPage from 'navigator-widget-ui-component';
import LibraryView from './views/facet-library/facet-library.vue';
import Guest from './views/guest/guest.vue';

Vue.use(Router);

const routes = [
  {
    path: '/',
    redirect: 'dashboard',
    component: AppHeaderLayout,
    children: [
      {
        path: '/dashboard',
        name: 'dashboard',
        // component: () => import('@/routers/views/libraries/libraries.vue'),
        component: () => import('@/routers/views/dashboard/dashboard.vue'),

        meta: { isRequiredAuth: true, isSuperUser: true },
      },
      {
        path: '/usage-report',
        name: 'usage-report',
        component: () => import('@/routers/views/usage-report/usage-report.vue'),
        meta: { isRequiredAuth: true },
      },
      {
        path: '/coverage',
        name: 'usage-report',
        component: () => import('@/routers/views/coverage/coverage.vue'),
        meta: { isRequiredAuth: true },
      },
      {
        path: '/discover',
        name: 'usage-report',
        component: () => import('@/routers/views/discoverablity/discover.vue'),
        meta: { isRequiredAuth: true },
      },
      {
        path: '/usage-content',
        name: 'usage-content',
        component: () => import('@/routers/views/usage-content/usage-content.vue'),
        meta: { isRequiredAuth: true },
      },
      {
        path: '/threshold',
        name: 'threshold',
        component: () => import('@/routers/views/threshold/threshold.vue'),
        meta: { isRequiredAuth: true },
      },
      {
        path: '/catalog',
        name: 'catalog',
        component: () => import('@/routers/views/catalog/catalog.vue'),
        meta: { isRequiredAuth: true },
      },
      {
        path: '/facet-search',
        name: 'facet-search',
        component: () => import('@/routers/views/facets-search/facets-search.vue'),
        meta: { isRequiredAuth: true },
      },
      {
        path: '/catalog/my-content/bulk-upload',
        name: 'bulk-upload',
        component: () => import('@/routers/views/catalog/bulk-upload/bulk-upload.vue'),
        meta: { isRequiredAuth: true },
      },
      {
        path: '/catalog/my-content/request-upload',
        name: 'request-upload',
        component: () => import('@/routers/views/catalog/request-upload.vue'),
        meta: { isRequiredAuth: true },
      },
      {
        path: '/competency',
        name: 'competency',
        redirect: { path: '/competency/competency-map' },
        component: () => import('@/routers/views/competency/competency.vue'),
        children: [
          {
            path: '/competency/competency-map',
            name: 'competency-map',
            component: () => import('@/routers/views/competency/competency-tap/competency-tap.vue'),
            meta: { isRequiredAuth: true },
          },
          {
            path: '/competency/tree',
            name: 'competency-tree',
            component: () => import('@/routers/views/competency/tree/tree.vue'),
            meta: { isRequiredAuth: true },
          },
          {
            path: '/competency/crosswalk',
            name: 'competency-crosswalk',
            component: () => import('@/routers/views/competency/cross-walk/cross-walk.vue'),
            meta: { isRequiredAuth: true },
          },
          {
            path: '/competency/learning-map',
            name: 'competency-learning-map',
            component: () => import('@/routers/views/competency/learning-map/learning-map.vue'),
            meta: { isRequiredAuth: true },
          },
          {
            path: '/competency/gdot',
            name: 'competency-gdot',
            component: () => import('@/routers/views/competency/gdot/gdot.vue'),
            meta: { isRequiredAuth: true },
          },
          {
            path: '/competency/add-competency',
            name: 'add-competency',
            component: () => import('@/routers/views/competency/add-competency/add-competency.vue'),
            meta: { isRequiredAuth: true },
          },
        ],
      },
      {
        path: '/content-registry/:id',
        name: 'content-network-profile',
        component: () => import('@/routers/views/network/partners/partner-profile-details/partner-profile-details.vue'),
        meta: { isRequiredAuth: true },
      },
      {
        path: '/tool-registry/:id',
        name: 'tool-network-profile',
        component: () => import('@/routers/views/network/partners/partner-profile-details/partner-profile-details.vue'),
        meta: { isRequiredAuth: true },
      },
      {
        path: '/partner-registry/:id',
        name: 'partners-network-profile',
        component: () => import('@/routers/views/network/partners/partner-profile-details/partner-profile-details.vue'),
        meta: { isRequiredAuth: true },
      },
      {
        path: '/content-registry',
        name: 'content-registry',
        component: () => import('@/routers/views/learner-registry/content-registry/content-registry.vue'),
        meta: { isRequiredAuth: true },
      },
      {
        path: '/tool-registry',
        name: 'tool-registry',
        component: () => import('@/routers/views/learner-registry/tool-registry/tool-registry.vue'),
        meta: { isRequiredAuth: true },
      },
      {
        path: '/partner-registry',
        name: 'partner-registry',
        component: () => import('@/routers/views/learner-registry/partner-registry/partner-registry.vue'),
        meta: { isRequiredAuth: true },
      },

    ],
  },
  {
    path: '/',
    redirect: 'login',
    component: AppLayout,
    children: [
      {
        path: '/facet-library',
        name: 'facet-library',
        component: LibraryView,
        meta: { isRequiredAuth: false },
      },
      {
        path: '/guest',
        name: 'guest',
        component: Guest,
      },
      ...LoginPage.routerList(),
      {
        path: '/logout',
        name: 'logout',
        beforeEnter() {
          sessionService.deleteSession();
          window.location.href = '/login';
        },
      },
    ],
  },
  {
    path: '/share-url',
    name: 'share-url-link',
    component: ShareableLink,
    meta: {
      isShareableUrl: true,
    },
  },
];

const router = new Router({
  linkExactActiveClass: 'active',
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: (to, from, savedPosition) => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 });
      }, 500);
    });
  },
});


router.beforeEach((to, from, next) => {
  // Set the document title dynamically
  const isMyGooruHost = window.location.host.includes('mygooru.ai');
  document.title = `${isMyGooruHost ? 'MyGooru' : ''}  Library`;
  if (to.meta && to.meta.isRequiredAuth && !sessionService.isAuthorized()) {
    next({ path: '/login', query: { redirect: to.fullPath } });
  } else if (to.meta && to.meta.isSuperUser && sessionService.getSession()!.permissions
    && sessionService.getSession()!.permissions.indexOf('ALL_ACCESS') === -1) {
    next({ path: '/competency' });
  } else {
    next();
  }
});

export default router;
